import { getPhoneNumberCountryCodeAsNumber } from 'lib-shared-phone-numbers';
import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { AppDispatch } from 'bootstrap.store';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../../notifications/actions/notification';
import * as telephonyActions from '../../../telephony/actions/telephony';
import { transferToNumberActions } from '../actions/transferToNumberModal';
import TransferToNumberModal from '../components/transferToNumberModal';

const { telephonyResetHold } = telephonyActions.actions;
const { notificationAdd, notificationRemoveByType } = notificationActions;

const mapStateToProps = (state: RootReducerStateT) => {
  const selectedFromNumber = state.telephony.selectedFromNumber;
  let fromNumberCountryCode: number | undefined = 45;

  if (selectedFromNumber && selectedFromNumber.e164_format) {
    fromNumberCountryCode = getPhoneNumberCountryCodeAsNumber(
      selectedFromNumber.e164_format,
    );
  }

  // Restrict outbound numbers to the active call's PBX region so the Twilio
  // conference stays in the same datacenter after a transfer (IO-4117).
  //
  // `activeCallTokenRegion` is owned by the Twilio middleware: it is set when
  // the device switches edge for a call and cleared when the device shuts down.
  // The transfer modal can only be opened during an active call, so this value
  // is the single source of truth here. If it's null while the modal is open,
  // that's a real bug (call without a registered region) — the component logs a
  // Sentry breadcrumb so we hear about it instead of silently degrading.
  const restrictToRegion = state.telephony.activeCallTokenRegion ?? undefined;

  return {
    meta: state.transferToNumber.meta,
    ui: state.transferToNumber.ui,
    numberTransferRequests: state.transferToNumber.transferRequests,
    users: state.transferToNumber.users,
    metaConversation: state.transferToNumber.metaConversation,

    presenceMeta: state.presence.meta,
    profile: state.settings.profile.profile,
    presence: state.presence.presence,

    transferToQueueRequests: state.transferToQueue.requests,
    transferToAgentRequests: state.transferToAgent.transferRequests,

    fromNumberCountryCode: fromNumberCountryCode,
    selectedFromNumber,
    restrictToRegion,
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    transferToNumberAssistedRequest: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberAssistedRequest,
    ),
    transferToNumberBlindRequest: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberBlindRequest,
    ),

    transferToNumberAssistedResolve: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberAssistedResolve,
    ),

    getUsersByQuery: bindActionToPromise(
      dispatch,
      transferToNumberActions.transferToNumberGetUsersByQuery,
    ),

    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
    transferToNumberResetUsers: () =>
      dispatch(transferToNumberActions.transferToNumberResetUsers()),
    transferToNumberModalOpen: () =>
      dispatch(transferToNumberActions.transferToNumberModalOpen()),
    transferToNumberModalClose: () =>
      dispatch(transferToNumberActions.transferToNumberModalClose()),
    transferRequestStop: (csid: string) =>
      dispatch(transferToNumberActions.transferToNumberRequestStop({ csid })),
    notificationAdd: (payload: any) => dispatch(notificationAdd(payload)),
    notificationRemoveByType: (payload: any) =>
      dispatch(notificationRemoveByType(payload)),

    telephonyResetHold: () => dispatch(telephonyResetHold()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferToNumberModal as any);
